import React, { useState } from 'react';
import InfoCard from './InfoCard';
import ContactModal from './ContactModal';
import { useTheme } from '../context/ThemeContext';

const LeftSidebar = ({ currentTime, currentDate, profileData, bio }) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const { colors, theme, toggleTheme } = useTheme();

  const handleOpenContactModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <div className="w-full lg:w-[452px] flex flex-col p-2 sm:p-3 lg:p-4 relative lg:max-h-[calc(100vh-50px)] overflow-hidden" style={{ maxHeight: 'auto', overflow: 'auto' }}>
      {/* Dashed border with 16px gap - Desktop only */}
      <div
        className="hidden lg:block absolute top-4 right-0 bottom-[16px] w-0"
        style={{
          borderRight: `1px dashed ${colors.border}`,
          borderImageSource: `repeating-linear-gradient(to bottom, ${colors.border} 0, ${colors.border} 2px, transparent 2px, transparent 6px)`,
          borderImageSlice: 1
        }}
      ></div>

      {/* Profile Section */}
      <div className="flex items-center gap-4 pb-6 lg:mb-6 relative">
        <div
          className="hidden lg:block absolute bottom-0 left-0 right-0 h-0"
          style={{
            borderBottom: `1px dashed ${colors.border}`,
            borderImageSource: `repeating-linear-gradient(to right, ${colors.border} 0, ${colors.border} 2px, transparent 2px, transparent 6px)`,
            borderImageSlice: 1
          }}
        ></div>
        <div className="w-20 h-20 rounded-full bg-gray-800 overflow-hidden flex-shrink-0">
          <img
            src={profileData.image}
            alt={profileData.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <h1 className="text-[36px] sm:text-[48px] lg:text-[58px] font-bold leading-none mb-0" style={{ color: colors.textPrimary }}>{profileData.name}</h1>
          <p className="text-[14px] sm:text-[18px] lg:text-[20px] -mt-2" style={{ color: colors.textSecondary }}>{profileData.tagline}</p>
        </div>
      </div>

      {/* Time/Date and Message Grid */}
      <div className="grid grid-cols-2 gap-4 pb-6 lg:mb-6 relative">
        <div
          className="hidden lg:block absolute bottom-0 left-0 right-0 h-0"
          style={{
            borderBottom: `1px dashed ${colors.border}`,
            borderImageSource: `repeating-linear-gradient(to right, ${colors.border} 0, ${colors.border} 2px, transparent 2px, transparent 6px)`,
            borderImageSlice: 1
          }}
        ></div>
        <InfoCard
          icon={<svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" strokeWidth="2" />
            <path strokeWidth="2" d="M12 6v6l4 2" />
          </svg>}
          label={currentDate}
          value={currentTime}
        />
        <InfoCard
          icon={<svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>}
          label="Send Message"
          value='Say "Hello!"'
          valueColor="#f97204"
          onClick={handleOpenContactModal}
        />
      </div>

      {/* Bio - Scrollable Content */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden pb-4 lg:pb-[66px]" style={{ scrollbarWidth: 'thin', scrollbarColor: `${colors.border} ${colors.background}` }}>
        <p className="text-[20px] leading-snug mb-4" style={{ color: colors.textSecondary }}>{bio.short}</p>
        <p className="text-[20px] leading-snug" style={{ color: colors.textSecondary }}>{bio.long}</p>
      </div>

      {/* Location - Hidden on mobile, visible on desktop */}
      <div className="hidden lg:block absolute left-2 sm:left-3 lg:left-4" style={{ bottom: '16px' }}>
        <p className="text-[20px] sm:text-[28px] lg:text-[30px] font-bold leading-none" style={{ color: colors.textPrimary }}>{profileData.location}</p>
      </div>

      {isContactModalOpen && <ContactModal onClose={handleCloseContactModal} />}
    </div>
  );
};

export default LeftSidebar;




